function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useOverlayContext } from 'seagull';
import { ClientPreview } from "../../../../../components/ClientPreview/ClientPreview";
import { useStoreActions } from "../../../../../contexts";
import { useFetchOnMountIfDataStale } from "../../../../../hooks/useFetchOnMountIfDataStale";
import { Intent } from "../../../../../infra/access-control";
import { ActionButton, StepLayout } from "../../BusinessOnboardingWidget.utils";
import BrandLogoIcon from "./BrandLogoIcon";
import { jsx as _jsx } from "react/jsx-runtime";
export default function SetUpBrand() {
  const overlayContext = useOverlayContext();
  const {
    logBI
  } = useStoreActions();
  const {
    data: legalTerms
  } = useFetchOnMountIfDataStale(state => state.legalTerms, actions => actions.fetchLegalTerms());
  return /*#__PURE__*/_jsx(StepLayout, {
    id: "setupBrand",
    title: "Align the look and feel of your proposals with your brand",
    subtitle: "Strengthen your Brand and customize the customer journey from the first interaction by adding your logo and brand colors to your proposals.",
    actions: /*#__PURE__*/_jsx(ActionButton, {
      intent: Intent.BrandSetup,
      "data-testid": "onboarding-widget-setup-brand",
      loading: !legalTerms,
      loadingText: "Set up brand",
      onClick: () => {
        if (!legalTerms) return;
        logBI(11217);
        overlayContext.showModal({
          content: props => /*#__PURE__*/_jsx(ClientPreview, _objectSpread({
            type: "setupBrand",
            setupBrandInfo: {
              legalTerms
            }
          }, props))
        });
      },
      children: "Set up brand"
    }),
    icon: /*#__PURE__*/_jsx(BrandLogoIcon, {})
  });
}